import { createBrowserRouter } from 'react-router-dom'
import App from './App'

// composants de pages
import Accueil from './pages/Accueil'

// page d'erreur
import NotFound from './not-found'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/*',
        caseSensitive: true,
        element: <NotFound />,
      },
      {
        path: '/',
        element: <Accueil />,
      },
      {
        path: '/manager',
        element: <Accueil />,
      },
    ],
  },
])
